import { useEffect, useState} from 'react'
import icon from 'assets/img/icons/special-offers.svg'
import { createAPI } from 'services/api/api';
import { useAuth0 } from '@auth0/auth0-react';
import { usePopup } from 'hooks/usePopup';
import { useLocation } from 'react-router-dom';
import useProfile from 'hooks/useProfile';
import { useSoundPath } from 'hooks/useSoundPath';
import useActiveItem from 'hooks/useActiveItem';

const PurchaseWindowStart = ({ currentQuantity, nextStep }) => {

  const {pathname} = useLocation();
  const {activeItem} = useActiveItem()
  const api = createAPI();
  const [isLoading, setIsLoading] = useState(false);
  const { isLogged, balance } = useProfile();
  const {loginWithRedirect} = useAuth0();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const isUseAccountDisabled = false // balance < Number(activeItem.cost);

  const useAccountBalanceBtnHandler = () => {
    playSound('main');
    if (isLogged) {
      nextStep('confirm');
    } else {
      loginWithRedirect();
    }
  }

  const useCreditCardHandler = () => {
    playSound('main');
    setIsLoading(true);

    const payload = {
      card_series_id: activeItem.id,
      quantity: currentQuantity,
    }

    api.post('/venly/venly_checkout_session', payload).then((response) => {
      window.location.href = response.data.result.url;
    })
    .catch((error) => console.log(error))
    .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    if (isLogged) {
      setPopupHook({type: 'purchase'});
    }
  }, [isLogged]);

  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
      </header>
      <form className="purchase-form">
        <output className="purchase-form__output">
          <span>Price</span>
          <span>${(Number(activeItem.cost) * currentQuantity).toFixed(2)}</span>
        </output>
        <section className="purchase-form__balance">
          <span className="purchase-form__balance-title">Your account balance is:</span>
          <b className="purchase-form__balance-current">${balance ? balance : 0} USD</b>
          {
            balance < activeItem.cost && <p className="purchase-form__balance-error">Your balance is insufficient</p>
          }
        </section>
        <footer className="modal-window__footer">
          <button className="modal-window__footer-close" disabled={isUseAccountDisabled} type="button" onClick={useAccountBalanceBtnHandler}>Use account balance</button>
          {
            !pathname.includes('marketplace') && (
              <button className={`modal-window__footer-submit ${isLoading ? 'loading' : ''}`} disabled={isLoading} type="button" onClick={useCreditCardHandler}>
                Add Funds to My Account
              </button>
            )
          }
        </footer>
      </form>
    </>
  )
}

export default PurchaseWindowStart;
